import { useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { useInvoiceQuery } from '../../../api/gql';
import { SetPaidModule } from '../../../modules/dialogs/set-paid';
import { useSafeNavigation } from '../../../hooks/useSafeNavigation';

export const InvoiceSetPaidPage = () => {
  const { invoiceId } = useParams();
  const { safeNavigate } = useSafeNavigation();
  const queryClient = useQueryClient();

  if (!invoiceId) {
    throw new Error('Unexpected - route variable :invoiceId is missing.');
  }

  return (
    <SetPaidModule
      invoiceId={invoiceId}
      transNs={'page-invoice-set-paid'}
      onSuccess={({ setDueAmount }) => {
        queryClient.setQueryData(useInvoiceQuery.getKey({ id: setDueAmount.id }), {
          invoice: { ...setDueAmount },
        });
        safeNavigate(`..`);
      }}
    />
  );
};
